import React, { useState, useEffect } from "react";
import "../assets/css/privacy.css";
import Footer from "./footer";
import { FaFacebookF, FaGoogle, FaLinkedinIn, FaPinterest, FaXTwitter } from "react-icons/fa6";
import axios from "axios";
import configModule from '../../config.js';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });
    const [loading, setLoading] = useState(false);
    const config = configModule.config();

    useEffect(() => {
        setTimeout(() => {
            document
                .getElementById("college-top")
                ?.scrollIntoView({ behavior: "smooth" });
        }, 50);
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loading) return;

        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBaseUrl}/contact-now`,
                formData,
                {
                    headers: {
                        "x-api-key": config.apichKey,
                    },
                }
            );

            alert(response.data.message);

            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
            });
        } catch (error) {
            alert("Failed to send message.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="mainnav-container" id="college-top">
            <div className="adve_section w-100">
                <div className="adve_container">

                    <div className="adve_left contus-st">
                        <h4 className="adve_form_title">Connect With Us</h4>

                        <form className="adve_form adve_form-st" onSubmit={handleSubmit}>

                            <label>Name *</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />

                            <label>Email *</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />

                            <label>Contact No. *</label>
                            <input
                                type="text"
                                name="phone"
                                placeholder="Enter contact no"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />

                            <label>Message</label>
                            <textarea
                                rows="4"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                            />

                            <button
                                type="submit"
                                className="mt-5"
                                disabled={loading}
                            >
                                {loading ? "Sending..." : "Submit"}
                            </button>

                        </form>

                    </div>

                    <div className="adve_right-cus">

                        <p className="mb-2"><i className="fa fa-phone"></i>
                            : <a href="tel:9108703683">+91 9108703683</a> </p>
                        <p className="mb-2"><i className="fa fa-envelope-o"></i>
                            : <a href="mailto:info@campushunt.in">info@campushunt.in</a>
                        </p>
                        <p className="mb-2"><i className="fa fa-clock-o"></i>
                            : Monday - Friday: 9:00 AM to 6:00 PM</p>
                        <ul className="list-unstyled list-inline list-social-icons">

                            <div className="ch-social">
                                <a href="https://x.com/CampusHunt_in"><FaXTwitter /></a>
                                <a href="https://www.facebook.com/campushunt.in?ref=aymt_homepage_panel"><FaFacebookF /></a>
                                <a href="https://workspaceupdates.googleblog.com/2023/04/new-community-features-for-google-chat-and-an-update-currents%20.html"><FaGoogle /></a>
                                <a href="https://www.linkedin.com/login/?session_redirect=%2Fcompany%2F13445015%2F"><FaLinkedinIn /></a>
                                <a href="https://in.pinterest.com/campushunt/"><FaPinterest /></a>
                            </div>
                        </ul>

                    </div>

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ContactUs;